module.exports = __webpack_public_path__ + "static/media/toggle-on.f14063b4.svg";